import PropTypes from "prop-types"
import { Paper } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import { useTabs } from "../../../../../context/TabContext";
import CustomDataGrid from "../../../../../reusable-components/datagrid/CustomDataGrid"
import { COMPLETED_ORDERS } from "../../../../../reusable-components/datagrid/orderColumns";
import ManagerChipsWrapper from "../../../../../reusable-components/datagrid/ManagerChipsWrapper";
import { getUserOrders } from "../../../../../api/orders";

UserOrdersTab.propTypes = {
  user: PropTypes.object,
};
export default function UserOrdersTab({ user }) {

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { addNewTabAndNavigate } = useTabs();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await getUserOrders(user.email);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      enqueueSnackbar('Error fetching user orders data', { variant: 'error' });
      setIsLoading(false);
    }
  };
  
    useEffect(() => {
      fetchData();
    }, []);
  
    const manager = ManagerChipsWrapper(null, 'Orders');
    const columns = useMemo(() => {
      const arr = [...COMPLETED_ORDERS, manager];
      arr.splice(9, 1);
      return arr;
    }, []);
  
    const rowClick = (row) => {
      const filter = row.approved ? 'previous' : 'pending';
      navigate(`/dashboard/orders/${row.id}?filter=${filter}&back=userOrders&userId=${user.id}`);
    };
    
    return (
      <Paper>
       <CustomDataGrid
        gridId="user-orders"
        applyQuickFilter
        data={data}
        gridColumns={[...columns.slice(0, 7), ...columns.slice(8)]}
        defaultHiddenColumns={['department', 'vendorShipDate', 'itemCount', 'total', 'ticketIds', 'reviews']}
        getRowId={(row) => row.id}
        onRowClick={(params, e) => {
          const selection = window.getSelection().toString();
          if (selection.length > 0) return;
          if (e.deleteChip || e.addChip || e.openTicket || e.combine || e.confirmDialog) return;
          if (e.navigateToTickets) {
            addNewTabAndNavigate(`/dashboard/tickets/${e.navigateToTickets}`);
            return;
          }
          rowClick(params.row);
        }}
        disableRowSelectionOnClick
        checkboxTooltipText="Permission Required"
        checkboxTooltipCheck={(row) => row.locked}
        isRowSelectable={(params) => !params.row.locked}
        isLoading={isLoading}
        advancedFilter
        advancedSearchBase={'pendingOrders'}
      />
      </Paper>
    )
  }